// Features Data

export const featuresData = [
  {
    id: 1,
    title: "Web Development",
    des: "Proficient in React, HTML5, CSS3, JavaScript and responsive design frameworks. Strong track record of delivering high-quality websites and applications, optimizing user experiences, and collaborating effectively with cross-functional teams to meet project goals.",
  },
  {
    id: 2,
    title: "Software Engineering",
    des: "I am a highly analytical back-end developer with Python and SQL expertise. I develop efficient and secure systems that meet client needs.",
  },
  {
    id: 3,
    title: "Data Science",
    des: "Uses data-driven insights to help companies make better decisions. Has a strong background in mathematics and statistics and specializes in data analysis.",
  },
  {
    id: 4,
    title: "Artificial Intelligence & ML",
    des: "Enthusiastic artificial intelligence engineer seeking to deliver state-of-the-art AI solutions. Experience includes using algorithms and data mining for my own personal projects. Relevant skills include Machine Learning, Data Structures, and Debugging.",
  },
  {
    id: 5,
    title: "Indie Filmmaking & Writing",
    des: "A highly imaginative filmmaker with over 8 years of experience making a variety of films. I got so many ex I worked as a freelancer Asst. Director, Casting Director, and Actor in so many TVC, OVC, AV, MV, Drama, Web Series, Film & Media Projects with so many renowned Brands, Productions, and Directors of Bangladesh, and also I did a lot of Govt. Projects. Sometimes, I’m so proud to be a part of this growing industry. Also I made some commercial productions, documentaries and short films as an Indie Filmmaker.",
  },
  {
    id: 6,
    title:"Educator",
    des: "I’m also proud to be a Teacher. It’s been often 12 years since I worked as a Private Home Tutor and worked as a Lecturer in some Coaching centers. Sometimes I feel lucky to be a favorite teacher of a lot of students of mine.",
  },
];
